import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const GuidedTourContext = createContext({
    currentTour: null,
    registerTour: () => () => {},
    isTourActive: false,
    setTourActive: () => {},
});

export const GuidedTourProvider = ({ children }) => {
    const [currentTour, setCurrentTour] = useState(null);
    const [isTourActive, setIsTourActive] = useState(false);

    const registerTour = useCallback((tour) => {
        setCurrentTour(tour);
        return () => {
            setCurrentTour((previous) => (previous && previous.tourId === tour.tourId ? null : previous));
        };
    }, []);

    const setTourActive = useCallback((isActive) => {
        setIsTourActive(isActive);
    }, []);

    const value = useMemo(
        () => ({ currentTour, registerTour, isTourActive, setTourActive }),
        [currentTour, registerTour, isTourActive, setTourActive]
    );

    return <GuidedTourContext.Provider value={value}>{children}</GuidedTourContext.Provider>;
};

export const useGuidedTourContext = () => useContext(GuidedTourContext);
